import { render } from "./IpOSChamadosMensalDash.vue?vue&type=template&id=62bf4414&scoped=true"
import script from "./IpOSChamadosMensalDash.vue?vue&type=script&lang=js"
export * from "./IpOSChamadosMensalDash.vue?vue&type=script&lang=js"

import "./IpOSChamadosMensalDash.vue?vue&type=style&index=0&id=62bf4414&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62bf4414"]])

export default __exports__